import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { EnquiryProvider } from "@/context/EnquiryContext";

import PublicLayout from "@/components/site/PublicLayout";
import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import EnquiryPage from "@/pages/EnquiryPage";
import EnquirySuccess from "@/pages/EnquirySuccess";
import RequestQuote from "@/pages/RequestQuote";
import Contact from "@/pages/Contact";
import PriceList from "@/pages/PriceList";
import AdminSeo from "@/pages/admin/AdminSeo";
import AdminNavigation from "@/pages/admin/AdminNavigation";
import AdminActivity from "@/pages/admin/AdminActivity";
import { NewArrivalsPage, DealsPage } from "@/pages/ListingPages";
import { Wholesale, Dealers, Corporate, About, FAQ, Privacy, Terms, Shipping } from "@/pages/StaticPages";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProducts from "@/pages/admin/AdminProducts";
import { AdminCategories, AdminBrands, AdminReviews, AdminOffers } from "@/pages/admin/AdminResources";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminQuotations from "@/pages/admin/AdminQuotations";
import { AdminSettings, AdminHomepage, AdminCustomers, AdminMedia } from "@/pages/admin/AdminMisc";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SettingsProvider>
          <EnquiryProvider>
            <Toaster richColors position="top-right"/>
            <Routes>
              <Route element={<PublicLayout/>}>
                <Route path="/" element={<Home/>}/>
                <Route path="/products" element={<Products/>}/>
                <Route path="/products/:slug" element={<ProductDetail/>}/>
                <Route path="/enquiry" element={<EnquiryPage/>}/>
                <Route path="/enquiry/success" element={<EnquirySuccess/>}/>
                <Route path="/request-quote" element={<RequestQuote/>}/>
                <Route path="/wholesale" element={<Wholesale/>}/>
                <Route path="/dealers" element={<Dealers/>}/>
                <Route path="/corporate" element={<Corporate/>}/>
                <Route path="/new-arrivals" element={<NewArrivalsPage/>}/>
                <Route path="/deals" element={<DealsPage/>}/>
                <Route path="/about" element={<About/>}/>
                <Route path="/contact" element={<Contact/>}/>
                <Route path="/price-list" element={<PriceList/>}/>
                <Route path="/faq" element={<FAQ/>}/>
                <Route path="/privacy" element={<Privacy/>}/>
                <Route path="/terms" element={<Terms/>}/>
                <Route path="/shipping" element={<Shipping/>}/>
              </Route>
              <Route path="/admin/login" element={<AdminLogin/>}/>
              <Route path="/admin" element={<AdminLayout/>}>
                <Route index element={<AdminDashboard/>}/>
                <Route path="products" element={<AdminProducts/>}/>
                <Route path="categories" element={<AdminCategories/>}/>
                <Route path="brands" element={<AdminBrands/>}/>
                <Route path="enquiries" element={<AdminEnquiries/>}/>
                <Route path="quotations" element={<AdminQuotations/>}/>
                <Route path="customers" element={<AdminCustomers/>}/>
                <Route path="reviews" element={<AdminReviews/>}/>
                <Route path="offers" element={<AdminOffers/>}/>
                <Route path="homepage" element={<AdminHomepage/>}/>
                <Route path="media" element={<AdminMedia/>}/>
                <Route path="seo" element={<AdminSeo/>}/>
                <Route path="navigation" element={<AdminNavigation/>}/>
                <Route path="activity" element={<AdminActivity/>}/>
                <Route path="settings" element={<AdminSettings/>}/>
              </Route>
            </Routes>
          </EnquiryProvider>
        </SettingsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
